import { compact, get } from 'lodash';
import { cropIds } from 'constants/crops';

// Objects as represented in Hank targetAvailableData query.
const cropCorn = { 'id': '6611a4f5-487d-11e6-a640-0e5557d5dd85', 'legacyId':cropIds.CORN, 'name': 'Corn' };
const cropSoybean = { 'id': '6611a7b5-487d-11e6-a640-0e5557d5dd85', 'legacyId':cropIds.SOYBEAN, 'name': 'Soybean' };
const avgYield = { 'q': 15960.559053712295, 'u': 'kg_hectare' };

// Use cases documented in 2018 Advanced Scripting SRD - https://docs.google.com/document/d/16OHMnqPaynsJ5-d7ROA_bKKHyqH8MrEX9DsS6V-0mPk/edit#heading=h.q0qkum352pwn

// Supporting "Success for Grower with Some Yield Data, Some CCI" use case in SRD.
export const someYieldSomeCci = {
  responseTransformers : [
    { urlMatch: /\/api\/hank\/v1/,
      bodyMatch: /targetAvailableData/,
      transformResponse: (response) => {
        // Delete all yield layers that aren't corn, and any corn layers beyond the first one found.
        const yieldLayers = get(response, 'data.targetAvailableData.yieldLayers', []);
        if (yieldLayers.length) {
          let foundOneCorn = false;
          yieldLayers.forEach((layer, index) => {
            if (layer.crop.legacyId === cropIds.CORN) {
              if (foundOneCorn) { yieldLayers[index] = undefined; }
              foundOneCorn = true;
            } else {
              yieldLayers[index] = undefined;
            }
          });
          response.data.targetAvailableData.yieldLayers = compact(response.data.targetAvailableData.yieldLayers);
        }
        return response;
      }
    }
  ]
};

// Supporting "Yield Data for Multiple Seasons in Same Year with Different Crops, No CCI" use case in SRD.
export const yieldDataMultipleSeasons1 = {
  responseTransformers : [
    { urlMatch: /\/api\/hank\/v1/,
      bodyMatch: /targetAvailableData/,
      transformResponse: (response) => {
        // Completely replace the yield and CCI layers to contrive the case.
        const availableData = get(response, 'data.targetAvailableData', []);
        if (availableData) {
          availableData.cciLayers = [];
          availableData.yieldLayers = [
            { 'season': '2014:corn:US:2:SPR', crop:cropCorn, avgYield }, // These 2 layers will cancel out.
            { 'season': '2014:corn:US:2:SUM', crop:cropSoybean, avgYield },
            { 'season': '2015:corn:US:2:SPR', crop:cropCorn, avgYield }, // These 2 layers of yield will remain.
            { 'season': '2016:corn:US:2:SPR', crop:cropCorn, avgYield }
          ];
        }
        return response;
      }
    }
  ]
};

// Yield Data for Multiple Seasons in Same Year with Different Crops, CCI Available
export const yieldDataMultipleSeasons2 = {
  responseTransformers : [
    { urlMatch: /\/api\/hank\/v1/,
      bodyMatch: /targetAvailableData/,
      transformResponse: (response) => {
        // Completely replace the yield layers, and add a CCI layer as needed to contrive the case.
        const availableData = get(response, 'data.targetAvailableData', []);
        if (availableData) {
          availableData.cciLayers = [...availableData.cciLayers, { season:'2014' }];
          availableData.yieldLayers = [
            { 'season': '2014:corn:US:2:SPR', crop:cropCorn, avgYield }, // These 2 layers will cancel out.
            { 'season': '2014:corn:US:2:SUM', crop:cropSoybean, avgYield },
            { 'season': '2015:corn:US:2:SPR', crop:cropCorn, avgYield }, // These 2 layers of yield will remain.
            { 'season': '2016:corn:US:2:SPR', crop:cropCorn, avgYield }
          ];
        }
        return response;
      }
    }
  ]
};

// Yield Data for Multiple Seasons in Same Year with Same Crop
export const yieldDataMultipleSeasons3 = {
  responseTransformers : [
    { urlMatch: /\/api\/hank\/v1/,
      bodyMatch: /targetAvailableData/,
      transformResponse: (response) => {
        // Completely replace the yield layers to contrive the case.
        const availableData = get(response, 'data.targetAvailableData', []);
        if (availableData) {
          availableData.yieldLayers = [
            { 'season': '2014:corn:US:2:SPR', crop:cropCorn, avgYield }, // These 2 layers will show.
            { 'season': '2014:corn:US:2:SUM', crop:cropCorn, avgYield },
            { 'season': '2015:corn:US:2:SPR', crop:cropCorn, avgYield } // One more layer for recommendation to be possible.
          ];
        }
        return response;
      }
    }
  ]
};
